const percentageFormatter = number => {
  return `${number} %`;
};

export default percentageFormatter;
